export function generateRandomNumberInGivenRange(min: number, range: number): number {
    const crypto = window.crypto;
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return min + (array[0] % range);
}
